import { baseAuthUrl } from "../api";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);
dayjs.extend(isToday);

const clientId =
  "UYs88zkZM3zKE1l9fo4AKOt7Dvp19gUE7VVRFG42rBTMQu9l-uBIOAlgGbWH0N2N";

export const goToLogin = () => {
  window.location.href = `${baseAuthUrl}/oauth2/authorize?response_type=code&scope=identity%20identity%5Bemail%5D%20identity.memberships&client_id=${clientId}&redirect_uri=${window.location.origin}/login`;
};

export const logout = () => {
  window.localStorage.clear();
  window.location.href = "/";
};

export const getFlagSource = (team) => {
  return `/flags/${team}.png`;
};

export const teamNames = {
  ATM: "ATM",
  BAY: "БАВ",
  PSG: "ПСЖ",
  AJX: "AЯК",
  ARS: "АРС",
  NAP: "НАП",
  ASM: "МОН",
  VIL: "ВІЛ",
  JUV: "ЮВЕ",
  DOR: "ДОР",
  LIV: "ЛІВ",
  SCP: "СПО",
  SLA: "СЛА",
  RMA: "РМА",
  BAR: "БAР",
  ATA: "АТА",
  OLY: "ОЛІ",
  CHE: "ЧЕЛ",
  LEV: "ЛЕВ",
  OM: "MAР",
  NEW: "НЬЮ",
  ATH: "АТЛ",
  GAL: "ГАЛ",
  MCI: "МАН",
  INT: "IНТ",
  PSV: "ПСВ",
  STG: "СТЖ",
  FRA: "ФРА",
  TOT: "TОТ",
  SLB: "БЕН",
  BRU: "БРЮ",
  BOD: "БДГ",
  PAF: "ПАФ",
  KAI: "КАЙ",
  KAR: "КАР",
  CPH: "КОП",
};

export const getTeamName = (teamId, teams, isMobile = false) => {
  if (!teamId) return;
  const targetTeam = teams.find((team) => team.TeamId === teamId);
  return isMobile ? teamNames[targetTeam?.TeamId] : targetTeam?.Name;
};

export const getPlayerNoString = (playerNo) => {
  if (!playerNo) return "";
  const digitsNumber = playerNo.toString().length;
  if (digitsNumber === 1) {
    return "00" + playerNo;
  } else if (digitsNumber === 2) {
    return "0" + playerNo;
  }

  return playerNo.toString();
};

export const getShownRound = (roundNumber) => {
  const ROUND_OFFSET = 0;
  return roundNumber - ROUND_OFFSET;
};

export const isLiveMatches = (roundMatches = []) => {
  const todayMatches = roundMatches.filter((match) =>
    dayjs(new Date(match.Deadline)).isToday(),
  );

  if (todayMatches.length === 0) return;

  let timeRangeForActions = {
    start: "",
    end: "",
  };

  if (todayMatches.length === 1) {
    timeRangeForActions.start = dayjs(new Date(todayMatches[0].Deadline));
    timeRangeForActions.end = timeRangeForActions.start
      .add(2, "hour")
      .add(15, "minutes");
  } else {
    timeRangeForActions.start = dayjs(new Date(todayMatches[0].Deadline));
    timeRangeForActions.end = dayjs(
      new Date(todayMatches[todayMatches.length - 1].Deadline),
    )
      .add(2, "hour")
      .add(15, "minutes");
  }

  const isTimeToAction = dayjs(new Date()).isBetween(
    timeRangeForActions.start,
    timeRangeForActions.end,
  );

  return isTimeToAction;
};
